<template>
  <rx-role :roles="roles">
    <v-btn
      v-if="!tooltipMessage"
      v-on="$listeners"
      v-bind="$attrs"
      class="no-uppercase"
    >
      <template #default>
        <slot name="default"></slot>
      </template>
      <template #loader>
        <slot name="loader"></slot>
      </template>
    </v-btn>
    <v-tooltip bottom v-if="tooltipMessage">
      <template v-slot:activator="{ on: onTooltip, attrs: attrsTootip }">
        <v-btn
          v-bind="{ ...$attrs, ...attrsTootip }"
          v-on="{ ...$listeners, ...onTooltip }"
        >
          <template #default>
            <slot name="default"></slot>
          </template>
          <template #loader>
            <slot name="loader"></slot>
          </template>
        </v-btn>
      </template>
      <span>{{ tooltipMessage ? tooltipMessage : label }}</span>
    </v-tooltip>
  </rx-role>
</template>

<script>
import RxRole from "@/redworks/components/base/RxRole";
export default {
  components: {
    RxRole,
  },
  props: {
    roles: {
      type: Array,
      default: null,
    },
    tooltipMessage: {
      type: String,
      default: "",
    },
    label: {
      type: String,
    },
  },
};
</script>

<style scoped>
.no-uppercase {
  text-transform: none;
}
</style>